module.exports = __webpack_public_path__ + "front/img/66.7056f74b.png";